<mcm-loader [loading]="loading() || !rows() || !columns()">
  @if (!loading() && rows() && columns()) {
    <div
      #scrollable
      (scroll)="onScroll($event)"
      [gridTpl]="{ columns: displayedColumns(), rows: displayedRows(), headerHeight: headerHeight(), rowHeight: rowHeight() }"
      class="mcm-table mcm-table--scrollable">

      @if (drawRowHolder()) {
        @for (row of displayedRows(); track trackByFn()($index, row); let rIdx = $index, isOdd = $odd, isEven = $even) {
          <div
            class="mcm-table__row-holder"
            [ngClass]="$any(row).styleClass"
            [class.odd]="isOdd"
            [class.even]="isEven"
            [style.grid-row-start]="2 + rIdx"
            [style.grid-row-end]="2 + rIdx + 1"
            [style.grid-column-start]="1"
            [style.grid-column-end]="1 + columns().length"></div>
        }
      }

      @for (
        column of displayedColumns();
        track column.key || $index;
        let cIdx = $index, isFirstColumn = $first, isLastColumn = $last
        ) {
        <div
          class="mcm-table__header"
          [ngClass]="column.styleClass"
          [ngStyle]="column.styles"
          [class.default]="!headerTpl()"
          [class.sticky]="stickyHeader()"
          [class.top]="stickyHeader()"
          [class.left]="stickyHeader() && isFirstColumn"
          [class.on-top]="stickyHeader() && isFirstColumn"
          [style.grid-row-start]="1"
          [style.gridColumn]="1 + cIdx"
          (click)="sort(cIdx)">

          @if (headerTpl()) {
            <ng-container
              [ngTemplateOutlet]="$any(headerTpl())"
              [ngTemplateOutletContext]="{
                column: column,
                index: cIdx,
                isFirstColumn: isFirstColumn,
                isLastColumn: isLastColumn
              }" />
          } @else {
            <div class="mcm-table__header-text">{{ column.label | translate }}</div>
          }

          @if (column.sortFn || column.sortable || sortable()) {
            <span
              class="mcm-table__header-sort"
              [ngClass]="column.sortDirection"></span>
          }
        </div>

        @for (
          row of displayedRows();
          track trackByFn()($index, row);
          let rIdx = $index, isFirstRow = $first, isLastRow = $last, isOdd = $odd, isEven = $even
          ) {
          <div
            class="mcm-table__row"
            [ngStyle]="rowStyles() || defaultRowStyles"
            [style.grid-row]="2 + rIdx"
            [style.grid-column]="1 + cIdx"
            [class.sticky]="column.sticky"
            [class.left]="column.sticky"
            [class.odd]="isOdd"
            [class.even]="isEven"
            [class.last-column]="isLastColumn"
            [class.first-column]="isFirstColumn"
            [ngClass]="$any(row).styleClass"
            (click)="cellClick.emit({ row: row, column: column, rowIdx: rIdx, columnIndex: cIdx })">

            @if (cellTpl()) {
              <ng-container
                [ngTemplateOutlet]="cellTpl()"
                [ngTemplateOutletContext]="{
                  row: row,
                  rowIndex: rIdx,
                  isFirstRow: isFirstRow,
                  isLastRow: isLastRow,
                  column: column,
                  columnIndex: cIdx,
                  isFirstColumn: isFirstColumn,
                  isLastColumn: isLastColumn,
                  isOdd: isOdd,
                  isEven: isEven
                }" />
            } @else {
              <div>{{ row[column.key] }}</div>
            }
          </div>
        }
      }
    </div>
  }
</mcm-loader>
